<template>
    <div>
        <b-card :title="$t('search-from-netbox')" class="mb-2">
            <b-form-group :label="$t('Y-Tunnus')">
                <b-form-input v-model="businessId" autocomplete="off"></b-form-input>
            </b-form-group>
				
            <b-form-group :label="$t('name')">
                <b-form-input v-model="businessName" autocomplete="off"></b-form-input>
            </b-form-group>
            
            <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
            >
                <b-button variant="outline-primary" @click.prevent="searchFromNetBox()"> {{ $t('search') }} </b-button>
            </b-overlay>
        </b-card>


        <b-modal id="bv-modal-example" hide-footer size="xl" :title="$t('choose-correct-company')">
            <b-overlay
                :show="modalOverlay"
                rounded="sm"
            >
                <div v-if="netBoxSearchedCompanies" class="searched-companies-container">
                    <b-form-group>
                        <b-button size="sm" @click="showAmount += 40;" variant="primary">
                            {{ $t('show-more') }}
                        </b-button>
                        <b-button 
                            size="sm" 
                            style="margin-left: 5px;" 
                            @click="showAmount = netBoxSearchedCompanies.length;" 
                            variant="info"
                        >
                            {{ $t('show-all') }} ({{ netBoxSearchedCompanies.length }})
                        </b-button>
                        <b-button size="sm" style="margin-left: 5px;" @click="showAmount = 5;" variant="secondary">
                            {{ $t('show-less') }}
                        </b-button>
                    </b-form-group>

                    <b-form-group>
                        <b-form-input v-model="searchParam" :placeholder="$t('search')+'..'"></b-form-input>
                    </b-form-group>

                    <b-table 
                        hover 
                        responsive 
                        :items="getTableRows.slice(0,showAmount)" 
                        :fields="getTableFields"
                        @row-clicked="setBusinessIdAndSearch($event)"
                    ></b-table>

                    <b-form-group>
                        <b-button size="sm" @click="showAmount += 40;" variant="primary">
                            {{ $t('show-more') }} 
                        </b-button>
                        <b-button 
                            size="sm" 
                            style="margin-left: 5px;" 
                            @click="showAmount = netBoxSearchedCompanies.length;" 
                            variant="info"
                        >
                            {{ $t('show-all') }} ({{ netBoxSearchedCompanies.length }})
                        </b-button>
                        <b-button size="sm" style="margin-left: 5px;" @click="showAmount = 5;" variant="secondary">
                            {{ $t('show-less') }}
                        </b-button>
                    </b-form-group>
                </div>
                <div v-else> {{ $t('no-results') }} </div>
            </b-overlay>
            <b-button class="mt-3" variant="outline-dark" block @click="$bvModal.hide('bv-modal-example')"> {{ $t('close') }} </b-button>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
export default {
	props: [],

    data(){
        return{
            businessId: "",
            businessName: "",
            netBoxSearchedCompanies: [],
            netBoxSearchedCompany: {},
            showAmount: 5,
            busy: false,
            searchParam: "",
            modalOverlay: false
        }
    },

	 created() {
		
		this.checkAutoCompleteParam();
	 },

    methods:{
        async searchFromNetBox(){
            if(this.businessId == "" && this.businessName == ""){
                alert("Lisää Y-Tunnus tai nimi hakeaksesi!");
                return;
            }

            if(this.businessId == "" && this.businessName.length < 3){
                alert("Nimessä pitää olla vähintään kolme kirjainta");
                return;
            }

            this.busy = true;
            this.showAmount = 5;

            this.resetData();

            if(this.businessId != ""){
                await this.searchWithBusinessId();
            }else{
                let nameResponse = await axios.get(`netbox/netBoxCompaniesName/${this.businessName}`);
			    this.netBoxSearchedCompanies = nameResponse.data.results;
                this.$bvModal.show('bv-modal-example')
            }

            this.busy = false;
        },

        async searchWithBusinessId(){
            this.busy = true;
            this.modalOverlay = true;
            // this.resetData();
            if(this.businessId != ""){
                let idResponse = await axios.get(`netbox/netBoxCompanyBusinessId/${this.businessId}`);
			    this.netBoxSearchedCompany = idResponse.data;
                this.$emit('business-set', this.netBoxSearchedCompany);
            }
            this.busy = false;
            this.modalOverlay = false;
        },

        async setBusinessIdAndSearch(e){
            let str = this.$t('Y-Tunnus')
            this.businessId = e[str];
            await this.searchWithBusinessId();
            this.$bvModal.hide('bv-modal-example');
        },

        resetData(){
            this.netBoxSearchedCompanies = [];
            this.netBoxSearchedCompany = {};
        },

		  checkAutoCompleteParam(){
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				
				if(urlParams.has('ac-bybusinessid')){

					const businessId = urlParams.get('ac-bybusinessid')
					this.businessId = businessId;
					
					this.searchFromNetBox();

				}


		  }
    },

    computed:{
        getTableRows(){
            let p = this.searchParam.toLowerCase();
            let x = this.netBoxSearchedCompanies.map(r => {
                if(r.name.toLowerCase().includes(p)){
                    // const rowObject = {
                    //     "Y-Tunnus": r.vat_identifier,
                    //     "Nimi": r.name,
                    //     "Kaupunki": r.domicile
                    // };
                    let rowObject = {};
                    rowObject[this.$t('Y-Tunnus')] = r.vat_identifier;
                    rowObject[this.$t('name')] = r.name;
                    rowObject[this.$t('city')] = r.domicile;
                    return rowObject;
                }else{
                    return null
                }
            })
            return x.filter(r => r != null);
        },
        getTableFields(){
            return [
                {
                    key: this.$t('Y-Tunnus'),
                    sortable: false
                },
                {
                    key: this.$t('name'),
                    sortable: true
                },
                {
                    key: this.$t('city'),
                    sortable: true,
                }
            ];
        }
    }
};

</script>

<style lang="scss" scoped>

    .searched-companies-container{
        margin-top: 20px;
    }

</style>
